import { useEffect, useState } from "react";
import { Calculator, Download, ExternalLink } from "lucide-react";
import { api, downloadPath, errMsg } from "@/lib/api";
import { toast } from "sonner";

export const CalcHubCard = () => {
  const [subs, setSubs] = useState(null);
  useEffect(() => { api.get("/subscribers").then((r) => setSubs(r.data)).catch(() => setSubs([])); }, []);
  const page = `${window.location.origin}/calculators`;
  return (
    <section className="border border-[#E2D9CC] bg-white p-6 space-y-4" data-testid="calc-hub-card">
      <p className="eyebrow flex items-center gap-2"><Calculator className="w-4 h-4" />Free calculators page</p>
      <p className="text-sm text-[#6B5B4E]">A public page listing every published town's property, tax and pet calculators, with side-by-side comparison, "Buy the full guide" links and an email signup. Link to it from theexpatstudio.com.</p>
      <div className="flex flex-wrap items-center gap-3">
        <a href="/calculators" target="_blank" rel="noreferrer" data-testid="calc-hub-open" className="inline-flex items-center gap-2 text-sm text-[#3B1B48] border border-[#3B1B48]/30 px-3 py-2 hover:bg-[#EFE6F3]"><ExternalLink className="w-4 h-4" />Open page</a>
        <button onClick={() => { navigator.clipboard.writeText(page); toast.success("Link copied"); }} data-testid="calc-hub-copy" className="text-sm text-[#8C827A] hover:text-[#3B1B48]">Copy link</button>
      </div>
      <div className="border-t border-[#E2D9CC] pt-4 flex flex-wrap items-center gap-3">
        <p className="text-sm mr-auto" data-testid="calc-hub-subscribers"><strong>{subs?.length ?? "…"}</strong> email signups{subs?.[0] ? ` · latest ${subs[0].email}` : ""}</p>
        {subs?.length > 0 && <button onClick={() => downloadPath("/subscribers.csv", "calculator-subscribers.csv").catch((e) => toast.error(errMsg(e)))} data-testid="calc-hub-csv" className="inline-flex items-center gap-2 text-sm text-[#3B1B48] hover:text-[#C59B27]"><Download className="w-4 h-4" />Download CSV</button>}
      </div>
    </section>
  );
};
